const initSlideToggle = async function () {
    const slideToggle = document.querySelectorAll('.slide-toggle__btn');

    slideToggle.forEach((e) => {
        e.addEventListener('click', () => {
            e.parentElement.classList.toggle("open");
        })
    })

    window.addEventListener('scroll', () => {
        slideToggle.forEach((e) => {
            e.parentElement.classList.remove("open");
        })
    });
};

export const init = initSlideToggle;